export default __webpack_public_path__ + "static/media/bg1.2f1f4ceb.jpg";